import React from 'react';
import PropTypes from 'prop-types';
import ReactLoading from 'react-loading';
import FlexContainer from '../flex-container';

const Loader = ({ size, color }) => {
  return (
    <FlexContainer justifyContent="center" alignItems="center" growToContainer>
      <ReactLoading
        type="spinningBubbles"
        height={size}
        width={size}
        delay={0}
        color={color}
      />
    </FlexContainer>
  );
};
Loader.defaultProps = {
  size: 200,
  color: '#F96D00',
};
Loader.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

export default Loader;
